module.exports = __webpack_public_path__ + "static/media/arrow.966771db.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NewProjectForm/arrow.png
// module id = 126
// module chunks = 0